module.exports = __webpack_public_path__ + "static/img/theme_07.4e028579.png";